import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, UrlSerializer } from '@angular/router';

import { routes } from './app.routes';
import { provideNzIcons } from './core/icons/icons-provider';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppInitService } from './services/app-init.service';
import { RegionUrlSerializer } from './services/region-url.serializer';
import { apiInterceptor } from './services/apis/api.interceptor';
import { provideTransloco, translocoConfig } from '@jsverse/transloco';
import { AVAILABLE_LANGS } from './core/i18n/i18n.config';
import { I18nService } from './core/i18n/i18n.service';
import { TranslocoHttpLoader } from './core/i18n/transloco-loader';
import zh from '@angular/common/locales/zh';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

registerLocaleData(en);
registerLocaleData(zh);
registerLocaleData(zh, 'zh-cn');
registerLocaleData(zh, 'zh-CN');

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(async () => {
      await inject(AppInitService).init();
    }),
    provideAppInitializer(async () => {
      await inject(I18nService).init();
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    {provide: UrlSerializer, useClass: RegionUrlSerializer},
    provideNzIcons(),
    provideNzI18n(en_US),
    // Monaco ≥0.52 needs absolute assets path for language workers (jsonWorker.js etc.)
    provideNzConfig({
      codeEditor: {
        assetsRoot: `${globalThis.location?.origin ?? ''}/assets`,
      },
    }),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideTransloco({
      config: translocoConfig({
        availableLangs: [...AVAILABLE_LANGS],
        defaultLang: 'en-US',
        fallbackLang: 'en-US',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      }),
      loader: TranslocoHttpLoader,
    }),
    provideNzDateFnsAdapter(),
  ],
};
